/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
import Immutable from 'immutable';
import normalize from '../../utils/normalize';
import { Notebooks, Notes } from '../../constants/actionTypes';

const initialState = {
  entities: {},
  seq: [],
  status: Notebooks.NOTEBOOKS_INIT,
};

export default function (state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    case Notebooks.GET_NOTEBOOKS:
      state = state.set('status', Notebooks.GET_NOTEBOOKS);
      return state;
    case Notebooks.GET_NOTEBOOKS_SUCCESS: {
      const { data, isCache } = action;
      if (!isCache) {
        const { entities, seq } = normalize(data);
        state = state.set('entities', Immutable.fromJS(entities).mergeDeep(state.get('entities')));
        state = state.set('seq', Immutable.fromJS(seq));
      }
      state = state.set('status', Notebooks.GET_NOTEBOOKS_SUCCESS);
      return state;
    }
    case Notebooks.GET_NOTEBOOKS_FAIL:
      state = state.set('status', Notebooks.GET_NOTEBOOKS_FAIL);
      return state;
    case Notebooks.SORT_NOTEBOOKS: {
      const { newSeq } = action;
      state = state.set('seq', Immutable.fromJS(newSeq));
      state = state.set('status', Notebooks.SORT_NOTEBOOKS);
      return state;
    }
    case Notebooks.SORT_NOTEBOOKS_SUCCESS: {
      state = state.set('status', Notebooks.SORT_NOTEBOOKS_SUCCESS);
      return state;
    }
    case Notebooks.SORT_NOTEBOOKS_FAIL: {
      const { oldSeq } = action;
      state = state.set('seq', Immutable.fromJS(oldSeq));
      state = state.set('status', Notebooks.SORT_NOTEBOOKS_FAIL);
      return state;
    }
    // 新建文集
    case Notebooks.NEW_NOTEBOOK: {
      state = state.set('status', Notebooks.NEW_NOTEBOOK);
      return state;
    }
    case Notebooks.NEW_NOTEBOOK_SUCCESS: {
      const { data } = action;
      state = state.setIn(['entities', `${data.id}`], Immutable.fromJS(data));
      state = state.set('seq', state.get('seq').unshift(data.id));
      state = state.set('status', Notebooks.NEW_NOTEBOOK_SUCCESS);
      return state;
    }
    case Notebooks.NEW_NOTEBOOK_FAIL: {
      state = state.set('status', Notebooks.NEW_NOTEBOOK_FAIL);
      return state;
    }
    // 删除文集
    case Notebooks.DEL_NOTEBOOK_SOFT: {
      const { nbId } = action;
      state = state.setIn(['entities', nbId.toString(), 'status'], Notebooks.DEL_NOTEBOOK_SOFT);
      return state;
    }
    case Notebooks.DEL_NOTEBOOK_SOFT_SUCCESS: {
      const { data, nbId } = action;
      const seqIndex = state.get('seq').findIndex(item => item === nbId);
      // entities中的key是string，seq中是数字，在Immutable中string和number有本质区别
      state = state.deleteIn(['entities', nbId.toString()]);
      state = state.deleteIn(['seq', seqIndex]);
      return state;
    }
    case Notebooks.DEL_NOTEBOOK_SOFT_FAIL: {
      const { data, nbId } = action;
      state = state.setIn(['entities', nbId.toString(), 'status'], Notebooks.DEL_NOTEBOOK_SOFT_FAIL);
      return state;
    }

    // 重命名文集
    case Notebooks.RENAME_NOTEBOOK: {
      const { data, nbId, name } = action;
      state = state.setIn(['entities', nbId.toString(), 'status'], Notebooks.RENAME_NOTEBOOK);
      return state;
    }
    case Notebooks.RENAME_NOTEBOOK_SUCCESS: {
      const { data, nbId, name } = action;
      state = state.setIn(['entities', nbId.toString(), 'name'], name);
      state = state.setIn(['entities', nbId.toString(), 'status'], Notebooks.RENAME_NOTEBOOK_SUCCESS);
      return state;
    }
    case Notebooks.RENAME_NOTEBOOK_FAIL: {
      const { data, nbId, name } = action;
      state = state.setIn(['entities', nbId.toString(), 'status'], Notebooks.RENAME_NOTEBOOK_FAIL);
      return state;
    }
    
    // 处理文章相关操作
    case Notes.GET_NOTES_SUCCESS: {
      const { nbId, data, page, count } = action;
      // 更新文集中的文章列表
      if (nbId && data) {
        const noteIds = data.map(note => note.id);
        // 如果是第一页，直接使用新数据；否则将新数据追加到现有数据后面
        if (page === 1) {
          state = state.setIn(['entities', nbId.toString(), 'notes'], Immutable.fromJS(noteIds));
        } else {
          // 获取当前文章列表
          const currentNotes = state.getIn(['entities', nbId.toString(), 'notes'], Immutable.List());
          // 将新文章追加到现有列表后面
          const updatedNotes = currentNotes.concat(Immutable.fromJS(noteIds));
          state = state.setIn(['entities', nbId.toString(), 'notes'], updatedNotes);
        }
      }
      return state;
    }
       // sort文章
    case Notes.SORT_NOTES: {
      const { nbId, newSeq } = action;
      state = state.setIn(['entities', nbId.toString(), 'notes'], Immutable.fromJS(newSeq));
      return state;
    }
    case Notes.SORT_NOTES_FAIL: {
      const { nbId, oldSeq } = action;
      state = state.setIn(['entities', nbId.toString(), 'notes'], Immutable.fromJS(oldSeq));
      return state;
    }
    case Notes.NEW_NOTE_SUCCESS: {
      const { data, nbId,atBottom,hasTop  } = action;
      // 将新文章添加到文集的文章列表中
      //const notesPath = ['entities', nbId.toString(), 'notes'];
      //const notes = state.getIn(notesPath, Immutable.List());
      //state = state.setIn(notesPath, notes.push(data.id));
      const noteSeqPath = ['entities', nbId.toString(), 'notes'];
      let notesSeq;
      if (atBottom) {
        // 加在尾部
        notesSeq = state.getIn(noteSeqPath).push(data.id);
      } else if (hasTop) {
        // 加在头部 (存在置顶文章)
        notesSeq = state.getIn(noteSeqPath).insert(1, data.id);
      } else {
        // 加在头部 (不存在置顶文章)
        notesSeq = state.getIn(noteSeqPath).unshift(data.id);
      }
      state = state.setIn(noteSeqPath, notesSeq);
      return state;
    }
     // 软性删除文章
    case Notes.DEL_NOTE_SOFT_SUCCESS: {
      const { nbId, noteId } = action;
      const notesPath = ['entities', nbId.toString(), 'notes'];
      let notes = state.getIn(notesPath);
      notes = notes.filter(id => id !== +noteId);
      state = state.setIn(notesPath, notes);
      return state;
    }
     // 移动文章
    case Notes.MOVE_NOTE_SUCCESS: {
      const { data, nbId, newNbId, noteId } = action;
      // 从nbId中删除noteId
      const notesPath = ['entities', nbId.toString(), 'notes'];
      let notes = state.getIn(notesPath);
      const index = notes.findIndex(item => item === +noteId);
      notes = notes.delete(index);
      state = state.setIn(notesPath, notes);
      // push到newNbId中
      const newNotesPath = ['entities', newNbId.toString(), 'notes'];
      notes = state.getIn(newNotesPath);
      // 有数据才push，没有数据，后面会重新ajax获取
      if (notes) {
        notes = notes.unshift(+noteId);
        state = state.setIn(newNotesPath, notes);
      }
      return state;
    }
    default:
      return state;
  }
}

export const getState = state => state.Notebooks;



// WEBPACK FOOTER //
// ./src/reducers/Notebooks/NotebooksReducer.js